<template>
  <section id="search" :class="{ ready : this.isReady}">
    <label v-if="this.infoDay === null" class="nogeo" for="ville">Où vous situez-vous ?</label>
    <div class="container">
      <input v-model="ville" type="text" id="ville" :placeholder="placeholder" @keyup.enter="updateWeather"/>
      <button type="submit" @click="updateWeather" aria-label="Rechercher">
        <svg
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 511.999 511.999"
          style="enable-background:new 0 0 511.999 511.999;"
          xml:space="preserve"
        >
          <g>
            <g>
              <path
                d="M508.874,478.708L360.142,329.976c28.21-34.827,45.191-79.103,45.191-127.309c0-111.75-90.917-202.667-202.667-202.667 S0,90.917,0,202.667s90.917,202.667,202.667,202.667c48.206,0,92.482-16.982,127.309-45.191l148.732,148.732 c4.167,4.165,10.919,4.165,15.086,0l15.081-15.082C513.04,489.627,513.04,482.873,508.874,478.708z M202.667,362.667 c-88.229,0-160-71.771-160-160s71.771-160,160-160s160,71.771,160,160S290.896,362.667,202.667,362.667z"
              />
            </g>
          </g>
        </svg>
      </button>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import { gsap } from "gsap";

export default {
  name: "HomeSearch",
  data() {
    return {
      ville: null,
      placeholder: null
    };
  },
  computed: {
    ...mapState(["isReady", "infoDay", "infoForeCast"])
  },
  mounted() {
    if (this.infoDay) {
      this.placeholder = this.infoDay.data.name;
    }
  },
   watch: {
    "isReady" () {
      if (this.infoDay === null && this.isReady) {
        let tl = gsap.timeline({ delay: 0.5, duration: 0.1 });
        tl.fromTo(
          ".nogeo, input, svg",
          { opacity: 0, y: 10 },
          { opacity: 1, y: 0, stagger: 0.2}
        );
      }
    }
  },
  methods: {
    updateWeather() {
      this.$store.commit("updateContent", false);
      new Promise(resolve => {
        resolve(), this.$store.commit("updateWeather", this.ville);
      }).then(
        setTimeout(() => {
          this.$store.commit("updateForeCast", {
            lat: this.$store.state.infoDay.data.coord.lat,
            lon: this.$store.state.infoDay.data.coord.lon
          });
        }, 200),
        setTimeout(() => {
          this.$store.commit("updateContent", true);
        }, 1000)
      );
    }
  }
};
</script>

<style lang="scss">
@import "../scss/global";
@import "../scss/components/homeSearch";
</style>